export class AlumnoEvaluacion {
    alumnoid!: number;
    matricula!: string;
    nombre!: string;
    apellidopaterno!: string;
    apellidomaterno!: string;
    primernombre!: string;
    nivelid!: number;
    gradoid!: number;
    grupoid!: number;
    alumnoestatusid!: number;
    listapersonaaevaluar: any[] = [];
    listapreguntas: any[] = [];
    profesorid!: number;
    colaboradorid!: number;
    puesto!:string;
    departamento!:string;
    persona!: string;
    materia!: string;
    evaluacionpendienterelacionid!: number;
    urlfotografia: string = "";
    foto: string = "";
    bloquearevaluacion!: boolean;
    constructor(init?: Partial<AlumnoEvaluacion>) {
        Object.assign(this, init);
    }
}